import {CornerType} from "./model/corner-type";
import {ColorType} from "./box-service";

export class View {
	public static enableTallBox(): void {
		const el = document.querySelector('.add-cube__tall');

		if (el) {
			this.enableCubesMenuItem(el);
		}
	}

	public static disableTallBox(): void {
		const el = document.querySelector('.add-cube__tall');

		if (el) {
			this.disableCubesMenuItem(el);
		}
	}

	public static enableCorner(type: CornerType): void {
		if (type.is(CornerType.tallCorner)) {
			const el = document.querySelector('.add-cube__tall-corner');

			this.enableCubesMenuItem(el);
		}
		if (type.is(CornerType.smallCorner)) {
			const el = document.querySelector('.add-cube__small-corner');

			this.enableCubesMenuItem(el);
		}
	}

	public static disableCorner(type: CornerType): void {
		if (type.is(CornerType.tallCorner)) {
			const el = document.querySelector('.add-cube__tall-corner');

			this.disableCubesMenuItem(el);
		}
		if (type.is(CornerType.smallCorner)) {
			const el = document.querySelector('.add-cube__small-corner');

			this.disableCubesMenuItem(el);
		}
	}

	public static enableDisableCubeOptionInMenu(enable: boolean, part: string) {
		if (enable) {
			const doc = document.querySelector(`.style-button-${part}`);

			this.enableCubeMenuItem(doc);
		} else {
			const doc = document.querySelector(`.style-button-${part}`);

			this.disableCubeMenuItem(doc);
		}
	}

	public static showHideCubeMenuItem(show: boolean, part: string) {
		if (show) {
			const doc = document.querySelector(`.style-button-${part}`);

			this.showElement(doc);
		} else {
			const doc = document.querySelector(`.style-button-${part}`);

			this.hideElement(doc);
		}
	}

	public static showHideCubeMenuUsageNote(show: boolean) {
		if (show) {
			const doc = document.querySelector(`.style-info`);

			this.showElement(doc);
		} else {
			const doc = document.querySelector(`.style-info`);

			this.hideElement(doc);
		}
	}

	public static showHideCubeMenuNote(show: boolean) {
		if (show) {
			const doc = document.querySelector(`.style-cube-info`);

			this.showElement(doc);
		} else {
			const doc = document.querySelector(`.style-cube-info`);

			this.hideElement(doc);
		}
	}

	public static updateCubeSelectionInMenu(enable: boolean, part: string, text?: string | undefined) {
		if (enable) {
			const doc = document.querySelector(`.style-button-${part}`);

			if (doc.lastElementChild.classList.contains('border-transparent') && !doc.lastElementChild.classList.contains('border-indigo-500')) {
				doc.lastElementChild.classList.remove('border-transparent')
				doc.lastElementChild.classList.add('border-indigo-500');
			}

			const buttonTextElement = doc.querySelector(".style-button-text");

			if (buttonTextElement && text) {
				buttonTextElement.innerHTML = text;
			}
		} else {
			const doc = document.querySelector(`.style-button-${part}`);

			if (doc.lastElementChild.classList.contains('border-indigo-500')
				&& !doc.lastElementChild.classList.contains('border-transparent')) {
				doc.lastElementChild.classList.remove('border-indigo-500');
				doc.lastElementChild.classList.add('border-transparent');
			}

			const buttonTextElement = doc.querySelector(".style-button-text");

			if (buttonTextElement && text) {
				buttonTextElement.innerHTML = text;
			}
		}
	}

	public static updateButtons(color: ColorType) {
		const toggleButton = document.getElementById('toggle-color-button');

		if (toggleButton) {
			if (color === "n") {
				toggleButton.innerHTML = 'Natural finish';
			} else {
				toggleButton.innerHTML = 'Walnut finish';
			}
		}
	}

	private static enableCubeMenuItem(element: Element) {
		element.classList.remove('bg-gray-300');
		element.classList.remove('cursor-not-allowed');

		element.classList.add('hover:border-gray-400');
		element.classList.add('cursor-pointer');
	};

	private static disableCubeMenuItem(element: Element) {
		element.classList.remove('hover:border-gray-400');
		element.classList.remove('cursor-pointer');

		element.classList.add('bg-gray-300');
		element.classList.add('cursor-not-allowed');
	}

	private static disableCubesMenuItem(element: Element) {
		element.classList.add('bg-gray-300');
		element.classList.add('cursor-not-allowed');

		element.classList.remove('bg-blue-600');
		element.classList.remove('hover:bg-blue-700');
		element.classList.remove('cursor-pointer');

		if (element instanceof HTMLButtonElement) {
			element.disabled = true;
		}
	};

	private static enableCubesMenuItem(element: Element) {
		element.classList.remove('bg-gray-300');
		element.classList.remove('cursor-not-allowed');

		element.classList.add('bg-blue-600');
		element.classList.add('hover:bg-blue-700');
		element.classList.add('cursor-pointer');

		if (element instanceof HTMLButtonElement) {
			element.disabled = false;
		}
	};

	private static showElement(element: Element) {
		if (element.classList.contains('hidden') && !element.classList.contains('sm:flex')) {
			element.classList.remove('hidden');
			element.classList.add('sm:flex');
		}
	};

	private static hideElement(element: Element){
		if (!element.classList.contains('hidden') && element.classList.contains('sm:flex')) {
			element.classList.add('hidden');
			element.classList.remove('sm:flex');
		}
	};
}
